var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCurvedWhiteArrow = function SvgCurvedWhiteArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76 1.891a37.545 37.545 0 0015.064 14.921c3.11 1.682 6.507 2.937 9.991 3.599 3.239.61 6.89.596 9.758-1.232 2.373-1.508 3.536-4.191 3.157-6.963-.332-2.503-2.081-4.806-4.748-4.928-3.267-.15-5.741 2.768-6.52 5.682-.863 3.246-.017 6.612 1.718 9.417 4.912 7.955 14.867 8.715 23.31 8.998 1.436.045 1.734-2.186.288-2.231-6.456-.208-13.907-.373-19.056-4.85-2.031-1.764-3.672-4.204-4.195-6.873-.523-2.669.07-5.849 2.493-7.361 2.192-1.36 4.17.185 4.47 2.472.3 2.287-.871 4.254-2.981 5.211-2.583 1.18-5.626.857-8.31.249-2.91-.658-5.721-1.767-8.354-3.165-5.847-3.135-10.805-8-14.007-13.817C5.144-.24 3.067.622 3.76 1.89z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.555 33.834c.565-1.097 1.215-1.934 1.981-2.879.078-.096 1.027-.968.938-1.165-.117-.256-.77-.473-.985-.602-.532-.321-1.021-.7-1.513-1.078-.766-.59-1.52-1.25-2.35-1.747",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
};
export default SvgCurvedWhiteArrow;